/* eslint-disable react/jsx-props-no-spreading */

import React from "react";

// Unique SVGs
import { ReactComponent as messageTailLeft } from "~assets/svg/message-tail-left.svg";
import { ReactComponent as messageTailRight } from "~assets/svg/message-tail-right.svg";
import { ReactComponent as starButton } from "~assets/svg/star-button.svg";
import { ReactComponent as wordmark } from "~assets/svg/wordmark.svg";

// Icon library
import { ReactComponent as arrowDown } from "~assets/svg/icon-library/arrow-down.svg";
import { ReactComponent as arrowLeft } from "~assets/svg/icon-library/arrow-left.svg";
import { ReactComponent as arrowRight } from "~assets/svg/icon-library/arrow-right.svg";
import { ReactComponent as cart } from "~assets/svg/icon-library/cart.svg";
import { ReactComponent as lookingGlass } from "~assets/svg/icon-library/looking-glass.svg";
import { ReactComponent as minus } from "~assets/svg/icon-library/minus.svg";
import { ReactComponent as playCircle } from "~assets/svg/icon-library/play-circle.svg";
import { ReactComponent as plus } from "~assets/svg/icon-library/plus.svg";
import { ReactComponent as starFilled } from "~assets/svg/icon-library/star-filled.svg";
import { ReactComponent as star } from "~assets/svg/icon-library/star.svg";
import { ReactComponent as sunFilled } from "~assets/svg/icon-library/sun-filled.svg";
import { ReactComponent as warningTriangle } from "~assets/svg/icon-library/warning-triangle.svg";
import { ReactComponent as x } from "~assets/svg/icon-library/x.svg";

const svgs = {
  // Unique
  messageTailLeft,
  messageTailRight,
  starButton,
  wordmark,

  // Library
  arrowDown,
  arrowLeft,
  arrowRight,
  cart,
  lookingGlass,
  minus,
  playCircle,
  plus,
  starFilled,
  star,
  sunFilled,
  warningTriangle,
  x
  // ... all icons as required
};

/** ============================================================================
 * @component
 * Used to render SVG icons
 *
 * @param {string}     svg     Name of desired SVG, must be imported first
 *
 * @return {node}
 */

const SVG = ({ svg, ...props }) => {
  if (!svgs[svg]) return null;

  const SVGElement = svgs[svg];

  return <SVGElement {...props} aria-hidden />;
};

export default SVG;
